import React from 'react';
import PropTypes from 'prop-types';
import ImageUploadOverlay from '../ImageUploadOverlay';
import { TORSO_CLIP_PATH, TORSO_CANVAS_SIZE } from '../../utils/displayUploadConfig';

/**
 * Torso-specific wrapper around the shared ImageUploadOverlay.
 * Passes the hardcoded torso clip-path polygon so existing behaviour is preserved.
 */
const TorsoImageUploadOverlay = ({
    imageData = null,
    onCompositeGenerated = () => {},
    torsoImageSrc = '',
    showDevMode = false,
    isProductAddedToBuild = false,
}) => (
    <ImageUploadOverlay
        imageData={imageData}
        onCompositeGenerated={onCompositeGenerated}
        baseImageSrc={torsoImageSrc}
        clipPathPoints={TORSO_CLIP_PATH}
        canvasSize={TORSO_CANVAS_SIZE}
        showDevMode={showDevMode}
        isProductAddedToBuild={isProductAddedToBuild}
        overlayClassName="torso-image-upload-overlay"
    />
);

TorsoImageUploadOverlay.propTypes = {
    imageData: PropTypes.shape({
        dataUri: PropTypes.string,
        position: PropTypes.shape({
            x: PropTypes.number,
            y: PropTypes.number,
            scale: PropTypes.number,
        }),
    }),
    onCompositeGenerated: PropTypes.func,
    torsoImageSrc: PropTypes.string,
    showDevMode: PropTypes.bool,
    isProductAddedToBuild: PropTypes.bool,
};

export default TorsoImageUploadOverlay;

// Re-export the composite blob helper from the shared module
export { generateCompositeBlob } from '../ImageUploadOverlay';
